import { ref, watch, Ref, onBeforeUnmount, WatchStopHandle } from 'vue-demi';

import { IAgentMultiUser } from '@/types';
import { getColorType } from '@/common';

export const getAgentMultiUserName = (user: IAgentMultiUser) => {
  return user?.data?.profile?.firstName && user.data.profile.lastName
    ? `${user.data.profile.firstName} ${user.data.profile.lastName}`
    : '';
};

/** Background color changes might */
export const useTrackBGColor = () => {
  const bgColorType = ref('' as 'light' | 'dark');

  let stop: WatchStopHandle = () => '';
  const trackBGColor = (args: { ref: HTMLElement; config: Ref; }) => {
    stop = watch(args.config, () => {
      const property = getComputedStyle(args.ref)['background'];
      bgColorType.value = getColorType(property);
    }, { immediate: true });
  };

  onBeforeUnmount(() => stop());
  return { bgColorType, trackBGColor };
};
